// =============================================================================
// Task Link Repository - Lier messages et tâches
// =============================================================================

import { supabase } from '@/integrations/supabase/client';
import type { TaskLinkType } from '../types';

export async function linkTaskToMessage(params: {
  orgId: string;
  messageId: string;
  taskId: string;
  linkType: TaskLinkType;
  createdBy: string;
}): Promise<void> {
  const { error } = await supabase
    .from('chat_message_task_links')
    .insert({
      org_id: params.orgId,
      message_id: params.messageId,
      task_id: params.taskId,
      link_type: params.linkType,
      created_by: params.createdBy,
    });

  if (error) throw error;
}

export async function unlinkTask(linkId: string): Promise<void> {
  const { error } = await supabase
    .from('chat_message_task_links')
    .delete()
    .eq('id', linkId);

  if (error) throw error;
}
